<template>
    <!--        Top bar-->
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <button class="button is-success" :disabled="!allStepsCompleted" @click="openSummaryModal">
                    <span class="icon">
                        <i class="fa fa-check" />
                    </span>
                    <span>{{ translate("notification_center.confirm_notification") }}</span>
                </button>
                <button class="button is-danger" @click="resetNotification">
                    <span class="icon">
                        <i class="fa fa-times" />
                    </span>
                    <span>{{ translate("common.reset") }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { eventBus, SUMMARY_MODAL_OPEN } from "../eventBus";
    import translatorMixin from "../../Common/translatorMixin";

    export default {
        name: "top-bar",
        mixins: [translatorMixin],
        computed: {
            ...mapGetters("main", ["allStepsCompleted"]),
        },
        methods: {
            openSummaryModal() {
                eventBus.$emit(SUMMARY_MODAL_OPEN);
            },
            resetNotification() {
                if (!confirm(this.translate("common.are_you_sure"))) {
                    return;
                }

                this.$store.dispatch("main/clearWholeLocalStorage");

                window.location.reload();
            },
        },
    };
</script>

<style scoped></style>
